export interface BrowserInfo {
  os: string
  browser: string
  browserVersion: string
}

function detectOS(ua: string): string {
  if (/windows/i.test(ua)) return 'Windows'
  if (/iphone|ipad|ipod/i.test(ua)) return 'iOS'
  if (/mac os x/i.test(ua)) return 'macOS'
  if (/android/i.test(ua)) return 'Android'
  if (/linux/i.test(ua)) return 'Linux'
  return 'Unknown'
}

function detectBrowser(ua: string): { browser: string; browserVersion: string } {
  const edgeMatch = /Edg\/([\d.]+)/.exec(ua)
  if (edgeMatch) return { browser: 'Edge', browserVersion: edgeMatch[1] }

  const firefoxMatch = /Firefox\/([\d.]+)/.exec(ua)
  if (firefoxMatch) return { browser: 'Firefox', browserVersion: firefoxMatch[1] }

  const chromeMatch = /Chrome\/([\d.]+)/.exec(ua)
  if (chromeMatch) return { browser: 'Chrome', browserVersion: chromeMatch[1] }

  const safariMatch = /Version\/([\d.]+)/.exec(ua)
  if (safariMatch && /Safari\//.test(ua)) {
    return { browser: 'Safari', browserVersion: safariMatch[1] }
  }

  return { browser: 'Unknown', browserVersion: 'Unknown' }
}

export function getBrowserInfo(userAgent: string = navigator.userAgent): BrowserInfo {
  const { browser, browserVersion } = detectBrowser(userAgent)
  return { os: detectOS(userAgent), browser, browserVersion }
}

export function getCountryCode(locale: string = navigator.language): string {
  try {
    const region = new Intl.Locale(locale).region
    if (region) return region
  } catch {
    // invalid BCP47 tag, fall through to the naive split below
  }

  const parts = locale.split('-')
  const last = parts.at(-1)
  if (parts.length > 1 && last && /^[A-Za-z]{2}$/.test(last)) return last.toUpperCase()

  return 'Unknown'
}
